import AudioPlayerSD from '../../ui/AudioPlayerSD';
import Table from '../../ui/Table';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';
import { PhotoMetadata } from './PhotoMetaData';
const audioExtensions = ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'];
const UploadFileSD = ({ dataTask }) => {
    const titleObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Title'));
    const descriptionObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Description'));
    const fileUrl = dataTask?.files?.join('');
    const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();

    const isAudio = fileUrl && audioExtensions.includes(fileExtension);
    const { timestamps, latitudes, longitudes } = dataTask?.submission || {};
    console.log(dataTask, 'see the data task here ');
    console.log(dataTask?.files, 'see the data task here');

    return (
        <Table.Row>
            <p className=" text-textPrimary flex flex-col   ">
                <span className="font-medium mb-1  "> {titleObject?.Title || '-'} </span>
                <span className="text-xs font-medium">{descriptionObject?.Description || '-'}</span>
            </p>
            <p className="text-sm justify-self-center">
                {microtaskTypeData.find((ele) => ele.type === dataTask.actionType).label}
            </p>

            <div>
                {fileUrl ? (
                    isAudio ? (
                        <>
                            <AudioPlayerSD src={fileUrl} title="Audio from API" className="max-w-lg" />
                            {timestamps && latitudes && longitudes && (
                                <PhotoMetadata
                                    timestamp={timestamps[0][0]}
                                    latitude={latitudes[0][0]}
                                    longitude={longitudes[0][0]}
                                    className=""
                                />
                            )}
                        </>
                    ) : (
                        <a href={fileUrl} download>
                            Download File
                        </a>
                    )
                ) : (
                    <span className="text-textSecondary mb-1">Not applicable</span>
                )}
            </div>
        </Table.Row>
    );
};

export default UploadFileSD;
